import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisV,
  faTable,
  faCaretUp,
  faCaretDown,
  faFilePdf,
} from "@fortawesome/free-solid-svg-icons";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Link } from "react-router-dom";
import { Chart as ChartJS } from "chart.js/auto";
import { Bar } from "react-chartjs-2";
import { BodyAsFormData } from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import { connect } from "react-redux";
import ChartExpandModal from "../../../services/utilities/ChartExpandModal";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class SectorWiseRentGraphOwner extends React.Component {
  static contextType = FilterContext;
  constructor(props) {
    super(props);
    this.state = {
      expandChartKey: Math.random(),
      expandChart: false,
      filters: "",
      tooltipClassname: null,
      tooltipArrow: faCaretUp,
      tooltipArrowDisplay: "none",
      tooltipYLabel: null,
      tooltipxLabel: null,
      chartOtions: {},
      chartData: {
        labels: [],
        datasets: [],
      },
      xAxis: [],
    };
  }

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }

    apiMiddleware
      .post("api/edge/office/get_owner_sector_rent", BodyAsFormData(filters))
      .then((res) => {
        this.setState({ xAxis: res.data.x });
      });

    this.state.filters = filters;
    const superClass = this;
    const options = {
      responsive: true,
      scales: {
        x: {
          grid: {
            display: false,
          },
          title: {
            display: true,
            text: "Sectors",
          },
          ticks: {
            callback: function (label, index, labels) {
              if (/\s/.test(superClass.state.xAxis)) {
                return superClass.state.xAxis[index].split(" ");
              } else {
                return superClass.state.xAxis[index];
              }
            },
            autoSkip: false,
          },
        },
        y: {
          grid: {
            display: true,
            drawBorder: true,
          },
          title: {
            display: true,
            text: "₹ / sqft / month",
          },
        },
      },
      plugins: {
        legend: {
          display: true,
          labels: {
            color: "rgb(0, 0, 0)",
            boxWidth: 6,
            boxHeight: 6,
            usePointStyle: true,
          },
        },
        title: {
          display: false,
        },
        tooltip: {
          enabled: true,
          y: "bottom",
          backgroundColor: "#000",
          external: function (context) {
            var className = "colorGreen";
            var arrowDir = faCaretUp;
            var CurrDataIndex = context.tooltip.dataPoints[0].dataIndex;
            var PrevDataIndex = CurrDataIndex == 0 ? 0 : CurrDataIndex - 1;

            if (
              parseFloat(
                context.tooltip.dataPoints[0].dataset.data[CurrDataIndex]
              ) <
              parseFloat(
                context.tooltip.dataPoints[0].dataset.data[PrevDataIndex]
              )
            ) {
              className = "colorRed";
              arrowDir = faCaretDown;
            }

            superClass.setState({
              tooltipClassname: className,
              tooltipArrow: arrowDir,
              tooltipArrowDisplay: "",
              tooltipYLabel: context.tooltip.dataPoints[0].parsed.y,
              tooltipxLabel: context.tooltip.dataPoints[0].label,
            });
          },
        },
      },
    };

    apiMiddleware
      .post("api/edge/office/get_owner_sector_rent", BodyAsFormData(filters))
      .then((res) => {
        const data = {
          labels: res.data.x,
          datasets: [
            {
              label: res.data.legend.y1,
              data: res.data.datapoints.y1,
              backgroundColor: res.data.bgcolor.y1,
              borderWidth: 0,
              barThickness: 10,
              borderRadius: 10,
            },
          ],
        };

        superClass.setState({
          chartOtions: options,
          chartData: data,
        });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters){
      this.setState({ filters: this.props.filters });

      const superClass = this;
      const options = {
        responsive: true,
        scales: {
          x: {
            grid: {
              display: false,
            },
            title: {
              display: true,
              text: "Sectors",
            },
            ticks: {
              callback: function (label, index, labels) {
                if (/\s/.test(superClass.state.xAxis)) {
                  return superClass.state.xAxis[index].split(" ");
                } else {
                  return superClass.state.xAxis[index];
                }
              },
              autoSkip: false,
            },
          },
          y: {
            grid: {
              display: true,
              drawBorder: true,
            },
            title: {
              display: true,
              text: "₹ / sqft / month",
            },
          },
        },
        plugins: {
          legend: {
            display: true,
            labels: {
              color: "rgb(0, 0, 0)",
              boxWidth: 6,
              boxHeight: 6,
              usePointStyle: true,
            },
          },
          title: {
            display: false,
          },
          tooltip: {
            enabled: true,
            y: "bottom",
            backgroundColor: "#000",
            external: function (context) {
              var className = "colorGreen";
              var arrowDir = faCaretUp;
              var CurrDataIndex = context.tooltip.dataPoints[0].dataIndex;
              var PrevDataIndex = CurrDataIndex == 0 ? 0 : CurrDataIndex - 1;

              if (
                parseFloat(
                  context.tooltip.dataPoints[0].dataset.data[CurrDataIndex]
                ) <
                parseFloat(
                  context.tooltip.dataPoints[0].dataset.data[PrevDataIndex]
                )
              ) {
                className = "colorRed";
                arrowDir = faCaretDown;
              }

              superClass.setState({
                tooltipClassname: className,
                tooltipArrow: arrowDir,
                tooltipArrowDisplay: "",
                tooltipYLabel: context.tooltip.dataPoints[0].parsed.y,
                tooltipxLabel: context.tooltip.dataPoints[0].label,
              });
            },
          },
        },
      };

      apiMiddleware
        .post(
          "api/edge/office/get_owner_sector_rent",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          const data = {
            labels: res.data.x,
            datasets: [
              {
                label: res.data.legend.y1,
                data: res.data.datapoints.y1,
                backgroundColor: res.data.bgcolor.y1,
                borderWidth: 0,
                barThickness: 10,
                borderRadius: 10,
              },
            ],
          };

          superClass.setState({
            chartOtions: options,
            chartData: data,
          });
        });
    }
  }
  downloadPdf() {
    const input = document.getElementById("sectorWiseRent");
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(imgData, "JPEG", 0, 0);
      pdf.save("sectorWiseRent.pdf");
    });
  }

  render() {
    return (
      <div className="widget widgetGraph" id="sectorWiseRent">
        <div className="row">
          <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
            <p>Sector-wise Rent</p>
            <h4 className={this.state.tooltipClassname}>
              <FontAwesomeIcon
                icon={this.state.tooltipArrow}
                style={{ display: this.state.tooltipArrowDisplay }}
              />
              {this.state.tooltipYLabel} &nbsp;
            </h4>
            <p className="colorBlack pSmall">
              {this.state.tooltipxLabel}&nbsp;
            </p>
          </div>
          <div className="col-lg-3 text-end">
            <p className="colorBlack downloads">
              <FontAwesomeIcon icon={faEllipsisV} />
              <ul className="downloadOptions">
                <li
                  className="pdfDownload"
                  onClick={(e) => {
                    this.downloadPdf();
                  }}
                >
                  <FontAwesomeIcon icon={faFilePdf} /> Download as PDF
                </li>
                <li
                  className="pdfDownload"
                  onClick={(e) => {
                    this.setState({
                      expandChart: true,
                      expandChartKey: Math.random(),
                    });
                  }}
                >
                  Expand Chart
                </li>
              </ul>
            </p>
          </div>
          <div className="col-lg-12">
            <Bar options={this.state.chartOtions} data={this.state.chartData} />
          </div>
        </div>
        <ChartExpandModal
          openModal={this.state.expandChart}
          chartName={SectorWiseRentGraphOwner}
          key={this.state.expandChartKey}
          filters={this.state.filters}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps)(SectorWiseRentGraphOwner);
